import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useSubmitEuAlignmentQuestionnaireMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MakeEuTaxonomyReportsEditable',
  props: {
    selected: null
  },
  setup: function setup(__props) {
    var _useSubmitEuAlignment = useSubmitEuAlignmentQuestionnaireMutation(),
      mutate = _useSubmitEuAlignment.mutate,
      loading = _useSubmitEuAlignment.loading;
    var selectedIds = ref([]);
    var handleReopenQuestionnaires = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(dialog) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all(selectedIds.value.map(function (questionnaireId) {
                return mutate({
                  questionnaireId: questionnaireId,
                  isEditable: true
                });
              }));
            case 2:
              dialog.value = false;
              window.$nuxt.$emit('userMsg');
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleReopenQuestionnaires(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      mutate: mutate,
      loading: loading,
      selectedIds: selectedIds,
      handleReopenQuestionnaires: handleReopenQuestionnaires
    };
  }
});